<template>
    <div
        class="settings"
        v-bind:class="{
            'settings--navigation-secondary-active':
                getSettingsPage !== null && getSettingsPage.indexOf('layout') === 0,
            'settings--content-active': getSettingsPage !== null && getSettingsPage !== 'layout'
        }"
    >
        <div class="settings__navigation-primary">
            <app-controlhead
                title="Einstellungen"
                :show-close="true"
                :show-remove="false"
                :show-save="showSave"
                :show-global="false"
                @close="closeSettings()"
            ></app-controlhead>
            <ul class="setting-links">
                <li class="setting-links__list-item">
                    <a
                        class="setting-links__link"
                        v-bind:class="{
                            'setting-links__link--active': getSettingsPage === 'company'
                        }"
                        v-on:click.prevent="openSettings('company').catch(() => {})"
                        href="#"
                    >
                        <span class="setting-links__title">Stammdaten</span>
                        <span class="setting-links__desc" v-html="$helpers.uiText('G001')"></span>
                    </a>
                </li>
                <li class="setting-links__list-item">
                    <a
                        class="setting-links__link"
                        v-bind:class="{
                            'setting-links__link--active': getSettingsPage === 'openingtimes'
                        }"
                        v-on:click.prevent="openSettings('openingtimes').catch(() => {})"
                        href="#"
                    >
                        <span class="setting-links__title">Öffnungszeiten</span>
                        <span class="setting-links__desc" v-html="$helpers.uiText('G003')"></span>
                    </a>
                </li>
                <li class="setting-links__list-item">
                    <a
                        class="setting-links__link"
                        v-bind:class="{
                            'setting-links__link--active':
                                (getSettingsPage || '').indexOf('layout') > -1
                        }"
                        v-on:click.prevent="openSettings('layout').catch(() => {})"
                        href="#"
                    >
                        <span class="setting-links__title">Aussehen der Seite</span>
                        <span class="setting-links__desc" v-html="$helpers.uiText('G005')"></span>
                    </a>
                </li>
                <li class="setting-links__list-item">
                    <a
                        class="setting-links__link"
                        v-bind:class="{
                            'setting-links__link--active': getSettingsPage === 'newsticker'
                        }"
                        v-on:click.prevent="openSettings('newsticker').catch(() => {})"
                        href="#"
                    >
                        <span class="setting-links__title">Newsticker</span>
                        <span class="setting-links__desc" v-html="$helpers.uiText('G012')"></span>
                    </a>
                </li>
                <!--
                <li class="setting-links__list-item">
                    <a
                        class="setting-links__link"
                        v-bind:class="{
                            'setting-links__link--active': getSettingsPage === 'domain'
                        }"
                        v-on:click.prevent="openSettings('domain').catch(() => {})"
                        href="#"
                    >
                        <span class="setting-links__title">Domain</span>
                        <span class="setting-links__desc"
                            >Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam
                            nonumy eirmod tempor invidunt.</span
                        >
                    </a>
                </li>
                <li class="setting-links__list-item">
                    <a
                        class="setting-links__link"
                        v-bind:class="{
                            'setting-links__link--active': getSettingsPage === 'package'
                        }"
                        v-on:click.prevent="openSettings('package').catch(() => {})"
                        href="#"
                    >
                        <span class="setting-links__title">Ihr Paket</span>
                        <span class="setting-links__desc"
                            >Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam
                            nonumy eirmod tempor invidunt.</span
                        >
                    </a>
                </li>
                <li class="setting-links__list-item">
                    <a
                        class="setting-links__link"
                        v-bind:class="{
                            'setting-links__link--active': getSettingsPage === 'extensions'
                        }"
                        v-on:click.prevent="openSettings('extensions').catch(() => {})"
                        href="#"
                    >
                        <span class="setting-links__title">Erweiterungen</span>
                        <span class="setting-links__desc"
                            >Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam
                            nonumy eirmod tempor invidunt.</span
                        >
                    </a>
                </li>
                <li class="setting-links__list-item">
                    <a
                        class="setting-links__link"
                        v-bind:class="{ 'setting-links__link--active': getSettingsPage === 'help' }"
                        v-on:click.prevent="openSettings('help').catch(() => {})"
                        href="#"
                    >
                        <span class="setting-links__title">Hilfe</span>
                        <span class="setting-links__desc"
                            >Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam
                            nonumy eirmod tempor invidunt.</span
                        >
                    </a>
                </li>
                -->
            </ul>
        </div>

        <div
            class="settings__navigation-secondary"
            v-if="getSettingsPage !== null && getSettingsPage.indexOf('layout') === 0"
        >
            <app-controlhead
                :show-close="true"
                :show-remove="false"
                :show-save="showSave"
                :show-global="false"
                @close="closeSettings('')"
            ></app-controlhead>
            <ul class="setting-links">
                <li class="setting-links__list-item">
                    <a
                        class="setting-links__link"
                        v-bind:class="{
                            'setting-links__link--active': getSettingsPage === 'layout/colorscheme'
                        }"
                        v-on:click.prevent="openSettings('layout/colorscheme').catch(() => {})"
                        href="#"
                    >
                        <span class="setting-links__title">Farben</span>
                        <span class="setting-links__desc" v-html="$helpers.uiText('G006')"></span>
                    </a>
                </li>
                <li class="setting-links__list-item">
                    <a
                        class="setting-links__link"
                        v-bind:class="{
                            'setting-links__link--active': getSettingsPage === 'layout/theme'
                        }"
                        v-on:click.prevent="openSettings('layout/theme').catch(() => {})"
                        href="#"
                    >
                        <span class="setting-links__title">Theme</span>
                        <span class="setting-links__desc" v-html="$helpers.uiText('G014')"></span>
                    </a>
                </li>
                <li class="setting-links__list-item">
                    <a
                        class="setting-links__link"
                        v-bind:class="{
                            'setting-links__link--active': getSettingsPage === 'layout/fontfamily'
                        }"
                        v-on:click.prevent="openSettings('layout/fontfamily').catch(() => {})"
                        href="#"
                    >
                        <span class="setting-links__title">Schriftart</span>
                        <span class="setting-links__desc" v-html="$helpers.uiText('G008')"></span>
                    </a>
                </li>
                <li class="setting-links__list-item">
                    <a
                        class="setting-links__link"
                        v-bind:class="{
                            'setting-links__link--active': getSettingsPage === 'layout/iconstyle'
                        }"
                        v-on:click.prevent="openSettings('layout/iconstyle').catch(() => {})"
                        href="#"
                    >
                        <span class="setting-links__title">Iconstil</span>
                        <span class="setting-links__desc" v-html="$helpers.uiText('G010')"></span>
                    </a>
                </li>
                <li class="setting-links__list-item">
                    <a
                        class="setting-links__link"
                        v-bind:class="{
                            'setting-links__link--active': getSettingsPage === 'layout/favicon'
                        }"
                        v-on:click.prevent="openSettings('layout/favicon').catch(() => {})"
                        href="#"
                    >
                        <span class="setting-links__title">Favicon</span>
                        <span class="setting-links__desc" v-html="$helpers.uiText('G017')"></span>
                    </a>
                </li>
            </ul>
        </div>

        <div
            class="settings__content"
            v-if="getSettingsPage !== null && getSettingsPage !== 'layout'"
        >
            <template v-if="getSettingsPage === 'company'">
                <div class="settings__content-scroll-wrap">
                    <app-controlhead
                        title="Stammdaten"
                        :help="$helpers.uiText('G002')"
                        :show-close="true"
                        :show-remove="false"
                        :show-save="showSave"
                        :show-global="false"
                        @close="closeSettings('')"
                    ></app-controlhead>
                    <div class="settings__content-wrap">
                        <app-text
                            label="Firmenname"
                            data-source="deha.user.firma1"
                            required
                            :maxlength="255"
                        ></app-text>

                        <div class="field-wrap field-text field-text--small">
                            <p v-html="$helpers.uiText('G016')"></p>
                        </div>

                        <app-text
                            label="Firmierung Zusatz"
                            data-source="deha.user.misc.firmierung"
                            :maxlength="255"
                        ></app-text>

                        <div class="settings__content-wrap-contact-persons">
                            <div
                                class="settings__content-wrap-group"
                                v-if="[1, 2, 3].includes(contactPersonCount)"
                            >
                                <app-select
                                    class="settings__content-field-salutation"
                                    label="Anrede"
                                    data-source="deha.user.misc.contact_person.salutation"
                                    :options="['Frau', 'Herr']"
                                    required
                                ></app-select>

                                <app-text
                                    class="settings__content-field-first-name"
                                    label="Inhaber Vorname"
                                    data-source="deha.user.misc.contact_person.first_name"
                                    required
                                    :maxlength="255"
                                ></app-text>

                                <app-text
                                    class="settings__content-field-last-name"
                                    label="Inhaber Nachname"
                                    data-source="deha.user.misc.contact_person.last_name"
                                    required
                                    :maxlength="255"
                                ></app-text>
                            </div>

                            <div
                                class="settings__content-wrap-group"
                                v-if="[2, 3].includes(contactPersonCount)"
                            >
                                <app-select
                                    class="settings__content-field-salutation"
                                    label="Anrede"
                                    data-source="deha.user.misc.contact_person_2.salutation"
                                    required
                                    :options="['Frau', 'Herr']"
                                ></app-select>

                                <app-text
                                    class="settings__content-field-first-name"
                                    label="Inhaber Vorname"
                                    data-source="deha.user.misc.contact_person_2.first_name"
                                    required
                                    :maxlength="255"
                                ></app-text>

                                <app-text
                                    class="settings__content-field-last-name"
                                    label="Inhaber Nachname"
                                    data-source="deha.user.misc.contact_person_2.last_name"
                                    required
                                    :maxlength="255"
                                ></app-text>
                            </div>

                            <div
                                class="settings__content-wrap-group"
                                v-if="[3].includes(contactPersonCount)"
                            >
                                <app-select
                                    class="settings__content-field-salutation"
                                    label="Anrede"
                                    data-source="deha.user.misc.contact_person_3.salutation"
                                    required
                                    :options="['Frau', 'Herr']"
                                ></app-select>

                                <app-text
                                    class="settings__content-field-first-name"
                                    label="Inhaber Vorname"
                                    data-source="deha.user.misc.contact_person_3.first_name"
                                    required
                                    :maxlength="255"
                                ></app-text>

                                <app-text
                                    class="settings__content-field-last-name"
                                    label="Inhaber Nachname"
                                    data-source="deha.user.misc.contact_person_3.last_name"
                                    required
                                    :maxlength="255"
                                ></app-text>
                            </div>

                            <div class="settings__contact-person-count-buttons">
                                <button
                                    class="button plus-button"
                                    v-on:click="increaseContactPersonCount"
                                    v-if="[1, 2].includes(contactPersonCount)"
                                ></button>
                                <span
                                    class="plus-minus-divider"
                                    v-if="[2].includes(contactPersonCount)"
                                ></span>
                                <button
                                    class="button minus-button"
                                    v-on:click="decreaseContactPersonCount"
                                    v-if="[2, 3].includes(contactPersonCount)"
                                ></button>
                            </div>
                        </div>

                        <app-text
                            label="Straße &amp; Hausnummer"
                            data-source="deha.user.strasse"
                            required
                            :maxlength="255"
                        ></app-text>

                        <app-text
                            label="Postleitzahl"
                            data-source="deha.user.plz"
                            pattern="^[0-9]{5,6}$"
                            required
                            :maxlength="255"
                        ></app-text>

                        <app-text
                            label="Ort"
                            data-source="deha.user.ort"
                            required
                            :maxlength="255"
                        ></app-text>

                        <app-select
                            label="Land"
                            data-source="deha.user.land"
                            :options="'Data.countries'"
                            required
                        ></app-select>

                        <app-text
                            label="Telefonnummer"
                            data-source="deha.user.telefon"
                            pattern="^(([+]{1,2}[0-9]{2,3})|[0]{1})[0-9]{0,10}[\(]{0,1}[0-9]{1,10}[\)]{0,1}[0-9]{1,10}[\s\|\/\|\-]{0,1}[0-9]{2,10}[\s\|\/\|\-]{0,1}[0-9]{0,10}$"
                            autoformat="phone"
                            required
                            :maxlength="255"
                        ></app-text>

                        <app-text
                            label="Faxnummer"
                            data-source="deha.user.fax"
                            pattern="^(([+]{1,2}[0-9]{2,3})|[0]{1})[0-9]{0,10}[\(]{0,1}[0-9]{1,10}[\)]{0,1}[0-9]{1,10}[\s\|\/\|\-]{0,1}[0-9]{2,10}[\s\|\/\|\-]{0,1}[0-9]{0,10}$"
                            autoformat="phone"
                            :maxlength="255"
                        ></app-text>

                        <app-text
                            label="E-Mail-Adresse"
                            data-source="deha.user.email"
                            pattern="^\S+@\S+\.\S{2,8}$"
                            required
                            :maxlength="255"
                        ></app-text>

                        <app-select
                            label="Rechtsform"
                            data-source="deha.user.rechtsform"
                            :options="'Data.companyForms'"
                            revalidate-source="company_form"
                        ></app-select>

                        <app-select
                            label="Registergericht"
                            data-source="deha.user.registergericht"
                            :options="'Data.registryCourts'"
                        ></app-select>

                        <app-text
                            label="Umsatzsteuernr."
                            data-source="deha.user.ustid"
                            pattern="^DE[0-9]{9}$"
                            :maxlength="255"
                            :required="getProp('deha.user.rechtsform') === 'GmbH'"
                            revalidate-target="company_form"
                        ></app-text>

                        <app-text
                            label="Handelsregisternr."
                            data-source="deha.user.handelsregisternummer"
                            :maxlength="255"
                            :required="getProp('deha.user.rechtsform') === 'GmbH'"
                        ></app-text>

                        <app-text
                            label="Notrufnummer"
                            data-source="deha.user.misc.emergency.phone"
                            pattern="^(([+]{1,2}[0-9]{2,3})|[0]{1})[0-9]{0,10}[\(]{0,1}[0-9]{1,10}[\)]{0,1}[0-9]{1,10}[\s\|\/\|\-]{0,1}[0-9]{2,10}[\s\|\/\|\-]{0,1}[0-9]{0,10}$"
                            autoformat="phone"
                            :maxlength="255"
                        ></app-text>

                        <app-radio
                            v-if="getProp('deha.user.misc.emergency.phone')"
                            data-source="deha.user.misc.emergency.visible"
                            :data-default="{ type: 'raw', value: 'outside' }"
                            :options="{
                                outside: 'Soll außerhalb meiner Geschäftszeiten angezeigt werden',
                                always: 'Soll immer angezeigt werden'
                            }"
                        ></app-radio>

                        <app-text
                            label="Alternative Telefonnummer"
                            data-source="deha.user.telefon_alt"
                            :data-default="{ type: 'source', value: 'deha.user.telefon' }"
                            pattern="^(([+]{1,2}[0-9]{2,3})|[0]{1})[0-9]{0,10}[\(]{0,1}[0-9]{1,10}[\)]{0,1}[0-9]{1,10}[\s\|\/\|\-]{0,1}[0-9]{2,10}[\s\|\/\|\-]{0,1}[0-9]{0,10}$"
                            autoformat="phone"
                            required
                            :maxlength="255"
                        ></app-text>

                        <app-text
                            label="Alternative Faxnummer"
                            data-source="deha.user.fax_alt"
                            pattern="^(([+]{1,2}[0-9]{2,3})|[0]{1})[0-9]{0,10}[\(]{0,1}[0-9]{1,10}[\)]{0,1}[0-9]{1,10}[\s\|\/\|\-]{0,1}[0-9]{2,10}[\s\|\/\|\-]{0,1}[0-9]{0,10}$"
                            autoformat="phone"
                            :data-default="{ type: 'source', value: 'deha.user.fax' }"
                            :maxlength="255"
                        ></app-text>

                        <app-text
                            label="Alternative E-Mail-Adresse"
                            data-source="deha.user.email_alt"
                            :data-default="{ type: 'source', value: 'deha.user.email' }"
                            pattern="^\S+@\S+\.\S{2,8}$"
                            required
                            :maxlength="255"
                        ></app-text>

                        <app-number
                            label="Gründungsjahr"
                            data-source="deha.user.gruendungsjahr"
                            :min="1850"
                            :max="new Date().getFullYear()"
                            required
                        ></app-number>

                        <div class="field-wrap field-text field-text--small">
                            <p v-html="$helpers.uiText('W046')"></p>
                        </div>

                        <app-text
                            label="Vorname"
                            data-source="deha.user.misc.responsible_for_content.first_name"
                            required
                            :maxlength="255"
                        ></app-text>

                        <app-text
                            label="Nachname"
                            data-source="deha.user.misc.responsible_for_content.last_name"
                            required
                            :maxlength="255"
                        ></app-text>

                        <app-text
                            label="Adresse"
                            data-source="deha.user.misc.responsible_for_content.address"
                            required
                            :maxlength="255"
                        ></app-text>

                        <!-- regulated profession -->
                        <div class="field-wrap field-text field-text--small">
                            <p v-html="$helpers.uiText('W047')"></p>
                        </div>

                        <app-select
                            label="Berufsregelungen liegen vor"
                            data-source="deha.user.misc.regulated_profession_applicable"
                            :options="{ 0: 'Nein', 1: 'Ja' }"
                            hide-clear
                            required
                        ></app-select>

                        <div class="settings__content-wrap-contact-persons"
                             v-if="getProp('deha.user.misc.regulated_profession_applicable') === '1'"
                            >

                            <div
                                class="settings__content-wrap-group"
                                v-if="[1, 2, 3].includes(regulatedProfessionCount)"
                            >
                                <app-text
                                    label="Berufsbezeichnung"
                                    data-source="deha.user.misc.regulated_profession.job_name"
                                    required
                                    :maxlength="255"
                                ></app-text>
                                <app-text
                                    label="Handwerkskammer"
                                    data-source="deha.user.misc.regulated_profession.chamber_name"
                                    required
                                    :maxlength="255"
                                ></app-text>
                                <app-text
                                    class="settings__content-field-chamber"
                                    label="Link Handwerkskammer"
                                    data-source="deha.user.misc.regulated_profession.chamber_link"
                                    pattern="^(https?:\/\/(www\.)?)?[\-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([\-a-zA-Z0-9@:%_\+.~#?\&\/\/=]*)$"
                                    autoformat="url"
                                    required
                                    :maxlength="255"
                                ></app-text>
                            </div>

                            <div
                                class="settings__content-wrap-group"
                                v-if="[2, 3].includes(regulatedProfessionCount)"
                            >
                                <app-text
                                    label="Berufsbezeichnung"
                                    data-source="deha.user.misc.regulated_profession_2.job_name"
                                    required
                                    :maxlength="255"
                                ></app-text>
                                <app-text
                                    label="Handwerkskammer"
                                    data-source="deha.user.misc.regulated_profession_2.chamber_name"
                                    required
                                    :maxlength="255"
                                ></app-text>
                                <app-text
                                    class="settings__content-field-chamber"
                                    label="Link Handwerkskammer"
                                    data-source="deha.user.misc.regulated_profession_2.chamber_link"
                                    pattern="^(https?:\/\/(www\.)?)?[\-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([\-a-zA-Z0-9@:%_\+.~#?\&\/\/=]*)$"
                                    autoformat="url"
                                    required
                                    :maxlength="255"
                                ></app-text>
                            </div>

                            <div
                                class="settings__content-wrap-group"
                                v-if="[3].includes(regulatedProfessionCount)"
                            >
                                <app-text
                                    label="Berufsbezeichnung"
                                    data-source="deha.user.misc.regulated_profession_3.job_name"
                                    required
                                    :maxlength="255"
                                ></app-text>
                                <app-text
                                    label="Handwerkskammer"
                                    data-source="deha.user.misc.regulated_profession_3.chamber_name"
                                    required
                                    :maxlength="255"
                                ></app-text>
                                <app-text
                                    class="settings__content-field-chamber"
                                    label="Link Handwerkskammer"
                                    data-source="deha.user.misc.regulated_profession_3.chamber_link"
                                    pattern="^(https?:\/\/(www\.)?)?[\-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([\-a-zA-Z0-9@:%_\+.~#?\&\/\/=]*)$"
                                    autoformat="url"
                                    required
                                    :maxlength="255"
                                ></app-text>
                            </div>

                            <div class="settings__contact-person-count-buttons">
                                <button
                                    class="button plus-button"
                                    v-on:click="increaseRegulatedProfessionCount"
                                    v-if="[1, 2].includes(regulatedProfessionCount)"
                                ></button>
                                <span
                                    class="plus-minus-divider"
                                    v-if="[2].includes(regulatedProfessionCount)"
                                ></span>
                                <button
                                    class="button minus-button"
                                    v-on:click="decreaseRegulatedProfessionCount"
                                    v-if="[2, 3].includes(regulatedProfessionCount)"
                                ></button>
                            </div>

                        </div>

                        <!-- Anzahl Mitarbeiter -->
                        <app-number
                            label="Anzahl Mitarbeiter"
                            data-source="deha.user.teamanzahl"
                            :min="0"
                            :max="100"
                            required
                        ></app-number>

                        <div class="field-wrap field-text field-text--small">
                            <p v-html="$helpers.uiText('W040')"></p>
                        </div>

                        <app-select
                            label="20 oder mehr personenbezogene daten-verarbeitende Personen"
                            data-source="deha.user.misc.needs_privacy_officer"
                            :options="{ 0: 'Nein', 1: 'Ja' }"
                            :data-default="{ type: 'raw', value: '0' }"
                            hide-clear
                            revalidate-source="privacy_officer"
                            required
                        ></app-select>

                        <div class="field-wrap field-text field-text--small">
                            <p v-html="$helpers.uiText('W041')"></p>
                        </div>

                        <app-text
                            v-show="needsPrivacyOfficer"
                            label="Vorname"
                            data-source="deha.user.misc.privacy_officer.first_name"
                            :data-default="{
                                type: 'source',
                                value: 'deha.user.misc.contact_person.first_name'
                            }"
                            :required="needsPrivacyOfficer"
                            revalidate-target="privacy_officer"
                            :maxlength="255"
                        ></app-text>

                        <app-text
                            v-show="needsPrivacyOfficer"
                            label="Nachname"
                            data-source="deha.user.misc.privacy_officer.last_name"
                            :data-default="{
                                type: 'source',
                                value: 'deha.user.misc.contact_person.last_name'
                            }"
                            :required="needsPrivacyOfficer"
                            revalidate-target="privacy_officer"
                            :maxlength="255"
                        ></app-text>

                        <app-text
                            v-show="needsPrivacyOfficer"
                            label="E-Mail-Adresse"
                            data-source="deha.user.misc.privacy_officer.email"
                            :data-default="{ type: 'source', value: 'deha.user.email' }"
                            pattern="^\S+@\S+\.\S{2,8}$"
                            :required="needsPrivacyOfficer"
                            revalidate-target="privacy_officer"
                            :maxlength="255"
                        ></app-text>

                        <app-text
                            v-show="needsPrivacyOfficer"
                            label="Telefonnummer"
                            data-source="deha.user.misc.privacy_officer.phone"
                            :data-default="{
                                type: 'source',
                                value: 'deha.user.telefon'
                            }"
                            pattern="^(([+]{1,2}[0-9]{2,3})|[0]{1})[0-9]{0,10}[\(]{0,1}[0-9]{1,10}[\)]{0,1}[0-9]{1,10}[\s\|\/\|\-]{0,1}[0-9]{2,10}[\s\|\/\|\-]{0,1}[0-9]{0,10}$"
                            autoformat="phone"
                            :required="needsPrivacyOfficer"
                            revalidate-target="privacy_officer"
                            :maxlength="255"
                        ></app-text>
                    </div>
                </div>
                <div class="settings__content-buttons">
                    <button
                        v-on:click.prevent="save"
                        :disabled="buttonDisabled"
                        class="button button--icon-checkmark"
                    >
                        Übernehmen &amp; Schließen
                    </button>
                </div>
            </template>

            <template v-if="getSettingsPage === 'openingtimes'">
                <div class="settings__content-scroll-wrap">
                    <app-controlhead
                        title="Öffnungszeiten"
                        :help="$helpers.uiText('G004')"
                        :show-close="true"
                        :show-remove="false"
                        :show-save="showSave"
                        :show-global="false"
                        @close="closeSettings('')"
                    ></app-controlhead>
                    <div class="settings__content-wrap">
                        <app-openingtimes
                            :data-source="'deha.user.misc.openingtimes'"
                        ></app-openingtimes>
                    </div>
                </div>
                <div class="settings__content-buttons">
                    <button
                        v-on:click.prevent="save"
                        :disabled="buttonDisabled"
                        class="button button--icon-checkmark"
                    >
                        Übernehmen &amp; Schließen
                    </button>
                </div>
            </template>

            <template v-if="getSettingsPage === 'layout/colorscheme'">
                <div class="settings__content-scroll-wrap">
                    <app-controlhead
                        title="Farben"
                        :help="$helpers.uiText('G007')"
                        :show-close="true"
                        :show-remove="false"
                        :show-save="showSave"
                        :show-global="false"
                        @close="closeSettings('layout')"
                    ></app-controlhead>
                    <div class="settings__content-wrap">
                        <app-colorscheme
                            data-source="tecpage.user.settings.colorscheme"
                            required
                        ></app-colorscheme>
                    </div>
                </div>
                <div class="settings__content-buttons">
                    <button
                        v-on:click.prevent="save"
                        :disabled="buttonDisabled"
                        class="button button--icon-checkmark"
                    >
                        Übernehmen &amp; Schließen
                    </button>
                </div>
            </template>

            <template v-if="getSettingsPage === 'layout/fontfamily'">
                <div class="settings__content-scroll-wrap">
                    <app-controlhead
                        title="Schriftart"
                        :help="$helpers.uiText('G009')"
                        :show-close="true"
                        :show-remove="false"
                        :show-save="showSave"
                        :show-global="false"
                        @close="closeSettings('layout')"
                    ></app-controlhead>
                    <div class="settings__content-wrap">
                        <app-fontfamily
                            data-source="tecpage.user.settings.fontfamily"
                            :data-default="{ type: 'raw', value: getFontfamilyDefault }"
                            required
                            :slide-view="false"
                        ></app-fontfamily>
                    </div>
                </div>
                <div class="settings__content-buttons">
                    <button
                        v-on:click.prevent="save"
                        :disabled="buttonDisabled"
                        class="button button--icon-checkmark"
                    >
                        Übernehmen &amp; Schließen
                    </button>
                </div>
            </template>

            <template v-if="getSettingsPage === 'layout/iconstyle'">
                <div class="settings__content-scroll-wrap">
                    <app-controlhead
                        title="Iconstil"
                        :help="$helpers.uiText('G011')"
                        :show-close="true"
                        :show-remove="false"
                        :show-save="showSave"
                        :show-global="false"
                        @close="closeSettings('layout')"
                    ></app-controlhead>
                    <div class="settings__content-wrap">
                        <app-iconstyle
                            data-source="tecpage.user.settings.iconstyle"
                            :data-default="{ type: 'raw', value: getIconstyleDefault }"
                            required
                        ></app-iconstyle>
                    </div>
                </div>
                <div class="settings__content-buttons">
                    <button
                        v-on:click.prevent="save"
                        :disabled="buttonDisabled"
                        class="button button--icon-checkmark"
                    >
                        Übernehmen &amp; Schließen
                    </button>
                </div>
            </template>

            <template v-if="getSettingsPage === 'layout/theme'">
                <div class="settings__content-scroll-wrap">
                    <app-controlhead
                        title="Theme"
                        :help="$helpers.uiText('G015')"
                        :show-close="true"
                        :show-remove="false"
                        :show-save="showSave"
                        :show-global="false"
                        @close="closeSettings('layout')"
                    ></app-controlhead>
                    <div class="settings__content-wrap">
                        <app-themepicker
                            data-source="tecpage.user.settings.theme"
                            :data-default="{ type: 'raw', value: getThemeDefault }"
                            required
                        ></app-themepicker>
                    </div>
                </div>
                <div class="settings__content-buttons">
                    <button
                        v-on:click.prevent="save"
                        :disabled="buttonDisabled"
                        class="button button--icon-checkmark"
                    >
                        Übernehmen &amp; Schließen
                    </button>
                </div>
            </template>

            <template v-if="getSettingsPage === 'layout/favicon'">
                <div class="settings__content-scroll-wrap">
                    <app-controlhead
                        title="Favicon"
                        :help="$helpers.uiText('G018')"
                        :show-close="true"
                        :show-remove="false"
                        :show-save="showSave"
                        :show-global="false"
                        @close="closeSettings('layout')"
                    ></app-controlhead>
                    <div class="settings__content-wrap">
                        <app-favicon
                            data-source="tecpage.user.settings.theme"
                            :data-default="{ type: 'raw', value: getThemeDefault }"
                            required
                        ></app-favicon>
                    </div>
                </div>
                <div class="settings__content-buttons">
                    <button
                        v-on:click.prevent="save"
                        :disabled="buttonDisabled"
                        class="button button--icon-checkmark"
                    >
                        Übernehmen &amp; Schließen
                    </button>
                </div>
            </template>

            <template v-if="getSettingsPage === 'newsticker'">
                <div class="settings__content-scroll-wrap">
                    <app-controlhead
                        title="Newsticker"
                        :help="$helpers.uiText('G013')"
                        :show-close="true"
                        :show-remove="false"
                        :show-save="showSave"
                        :show-global="false"
                        @close="closeSettings('')"
                    ></app-controlhead>
                    <div class="settings__content-wrap">
                        <app-text
                            label="Überschrift"
                            data-source="deha.user.misc.newsticker.title"
                            :data-default="{ type: 'textpicker' }"
                            textpicker-namespace="newsticker/title"
                            :maxlength="255"
                        ></app-text>

                        <app-wysiwyg
                            label="Text"
                            data-source="deha.user.misc.newsticker.text"
                            :data-default="{ type: 'textpicker' }"
                            textpicker-namespace="newsticker/text"
                            :maxlength="1024"
                        ></app-wysiwyg>

                        <app-datepicker
                            label="Meldung aktiv ab"
                            data-source="deha.user.misc.newsticker.valid_from"
                        ></app-datepicker>

                        <app-datepicker
                            label="Meldung aktiv bis"
                            data-source="deha.user.misc.newsticker.valid_until"
                        ></app-datepicker>
                    </div>
                </div>
                <div class="settings__content-buttons">
                    <button
                        v-on:click.prevent="save"
                        :disabled="buttonDisabled"
                        class="button button--icon-checkmark"
                    >
                        Übernehmen &amp; Schließen
                    </button>
                </div>
            </template>

            <!--
            <template v-if="getSettingsPage === 'domain'">
                <div class="settings__content-scroll-wrap">
                    <app-controlhead
                        title="TODO"
                        help="Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren."
                        :show-close="true"
                        :show-remove="false"
                        :show-save="showSave"
                        :show-global="false"
                        @close="closeSettings('')"
                    ></app-controlhead>
                    <div class="settings__content-wrap">TODO</div>
                </div>
                <div class="settings__content-buttons">
                    <button
                        v-on:click.prevent="save"
                        :disabled="buttonDisabled"
                        class="button button--icon-checkmark"
                    >
                        Übernehmen &amp; Schließen
                    </button>
                </div>
            </template>

            <template v-if="getSettingsPage === 'package'">
                <div class="settings__content-scroll-wrap">
                    <app-controlhead
                        title="TODO"
                        help="Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren."
                        :show-close="true"
                        :show-remove="false"
                        :show-save="showSave"
                        :show-global="false"
                        @close="closeSettings('')"
                    ></app-controlhead>
                    <div class="settings__content-wrap">
                        TODO
                    </div>
                </div>
                <div class="settings__content-buttons">
                    <button
                        v-on:click.prevent="save"
                        :disabled="buttonDisabled"
                        class="button button--icon-checkmark"
                    >
                        Übernehmen &amp; Schließen
                    </button>
                </div>
            </template>

            <template v-if="getSettingsPage === 'extensions'">
                <div class="settings__content-scroll-wrap">
                    <app-controlhead
                        title="TODO"
                        help="Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren."
                        :show-close="true"
                        :show-remove="false"
                        :show-save="showSave"
                        :show-global="false"
                        @close="closeSettings('')"
                    ></app-controlhead>
                    <div class="settings__content-wrap">
                        TODO
                    </div>
                </div>
                <div class="settings__content-buttons">
                    <button
                        v-on:click.prevent="save"
                        :disabled="buttonDisabled"
                        class="button button--icon-checkmark"
                    >
                        Übernehmen &amp; Schließen
                    </button>
                </div>
            </template>

            <template v-if="getSettingsPage === 'help'">
                <div class="settings__content-scroll-wrap">
                    <app-controlhead
                        title="TODO"
                        help="Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren."
                        :show-close="true"
                        :show-remove="false"
                        :show-save="showSave"
                        :show-global="false"
                        @close="closeSettings('')"
                    ></app-controlhead>
                    <div class="settings__content-wrap">
                        TODO
                    </div>
                </div>
                <div class="settings__content-buttons">
                    <button
                        v-on:click.prevent="save"
                        :disabled="buttonDisabled"
                        class="button button--icon-checkmark"
                    >
                        Übernehmen &amp; Schließen
                    </button>
                </div>
            </template>
            -->
        </div>
    </div>
</template>

<script>
import Text from '@/components/fields/simple/Text.vue';
import Number from '@/components/fields/simple/Number.vue';
import Datepicker from '@/components/fields/simple/Datepicker.vue';
import Wysiwyg from '@/components/fields/simple/Wysiwyg.vue';
import Select from '@/components/fields/simple/Select.vue';
import Radio from '@/components/fields/simple/Radio.vue';
import Fontfamily from '@/components/fields/simple/Fontfamily.vue';
import Colorscheme from '@/components/fields/simple/Colorscheme.vue';
import Themepicker from '@/components/fields/simple/Themepicker.vue';
import Iconstyle from '@/components/fields/simple/Iconstyle.vue';
import Favicon from '@/components/fields/simple/Favicon.vue';
import OpeningTimes from '@/components/fields/complex/OpeningTimes.vue';
import { mapActions, mapGetters } from 'vuex';
import Controlhead from '@/components/assorted/Controlhead';

export default {
    data() {
        return {
            contactPersonCount: 1,
            regulatedProfessionCount: 0,
            companyNameStored: ''
        };
    },
    components: {
        'app-controlhead': Controlhead,
        'app-text': Text,
        'app-number': Number,
        'app-datepicker': Datepicker,
        'app-wysiwyg': Wysiwyg,
        'app-select': Select,
        'app-radio': Radio,
        'app-fontfamily': Fontfamily,
        'app-colorscheme': Colorscheme,
        'app-themepicker': Themepicker,
        'app-iconstyle': Iconstyle,
        'app-openingtimes': OpeningTimes,
        'app-favicon': Favicon
    },
    methods: {
        ...mapActions([
            'openSettings',
            'closeSettings',
            'forgetDifferInRoute',
            'saveAllData',
            'removeProp',
            'deleteDifferInvalidField',
            'changeCompanyNameInAllModules'
        ]),
        async save() {
            let curPage = this.getSettingsPage,
                nextPage = '';
            if (curPage.indexOf('/') > -1) {
                nextPage = curPage.split('/')[0];
            }

            await this.changeCompanyNameInAllModules({
                search: this.companyNameStored,
                replace: this.getProp('deha.user.firma1')
            });
            this.companyNameStored = this.getProp('deha.user.firma1');

            await this.forgetDifferInRoute(this.getCurrentRouteFullPath);
            await this.closeSettings(nextPage);
            await this.saveAllData();
        },

        // handle contact person
        increaseContactPersonCount() {
            this.addContactPersonCount(1);
        },
        decreaseContactPersonCount() {
            this.addContactPersonCount(-1);
            ['salutation', 'first_name', 'last_name'].forEach((props__value) => {
                this.removeProp({
                    source:
                        'deha.user.misc.contact_person_' +
                        (this.contactPersonCount + 1) +
                        '.' +
                        props__value
                });
                this.deleteDifferInvalidField({
                    source:
                        'deha.user.misc.contact_person_' +
                        (this.contactPersonCount + 1) +
                        '.' +
                        props__value,
                    route: this.getCurrentRouteFullPath
                });
            });
        },
        addContactPersonCount(i) {
            let value = this.contactPersonCount;
            if (value !== undefined && value !== null && value !== '') {
                value = parseInt(value) + i;
            } else {
                value = 1;
            }
            this.contactPersonCount = value;
        },

        // handle regulated professions
        increaseRegulatedProfessionCount() {
            this.addRegulatedProfessionCount(1);
        },
        decreaseRegulatedProfessionCount() {
            this.addRegulatedProfessionCount(-1);
            ['job_name', 'chamber_name', 'chamber_link'].forEach((props__value) => {
                const currentCount = this.regulatedProfessionCount;
                const id = (currentCount == 0 ? '' : '_' + (currentCount + 1))
                this.removeProp({
                    source: 'deha.user.misc.regulated_profession' + id + '.' + props__value,
                });
                this.deleteDifferInvalidField({
                    source: 'deha.user.misc.regulated_profession' + id + '.' + props__value,
                    route: this.getCurrentRouteFullPath
                });
            });
        },
        addRegulatedProfessionCount(i) {
            let value = this.regulatedProfessionCount;
            if (value !== undefined && value !== null && value !== '') {
                value = parseInt(value) + i;
            } else {
                value = 1;
            }
            this.regulatedProfessionCount = value;
        },

    },
    computed: {
        ...mapGetters([
            'getCurrentRouteFullPath',
            'getSettingsPage',
            'differHasChangesInRoute',
            'differHasInvalidFieldsInRoute',
            'getProp',
            'getFontfamilyDefault',
            'getThemeDefault',
            'getIconstyleDefault',
            'needsPrivacyOfficer',
            'getCurrentRouteFullPath'
        ]),
        showSave() {
            return (
                this.differHasChangesInRoute(this.getCurrentRouteFullPath) &&
                !this.differHasInvalidFieldsInRoute(this.getCurrentRouteFullPath)
            );
        },
        buttonDisabled() {
            return this.differHasInvalidFieldsInRoute(this.getCurrentRouteFullPath);
        },
        regulatedProfessionApplicable() {
            return this.getProp('deha.user.misc.regulated_profession_applicable');
        },
    },
    watch: {
        regulatedProfessionApplicable(newVal) {
            if (newVal == '1') {
                this.addRegulatedProfessionCount(1);
            } else {
                if (this.regulatedProfessionCount === 3) {
                    this.decreaseRegulatedProfessionCount();
                }
                if (this.regulatedProfessionCount === 2) {
                    this.decreaseRegulatedProfessionCount();
                }
                if (this.regulatedProfessionCount === 1) {
                    this.decreaseRegulatedProfessionCount();
                }
            }
        },
    },
    created() {

        // set contact person count
        let counter = 1;
        if (
            this.getProp('deha.user.misc.contact_person_2.salutation') ||
            this.getProp('deha.user.misc.contact_person_2.first_name') ||
            this.getProp('deha.user.misc.contact_person_2.last_name')
        ) {
            counter = 2;
        }
        if (
            this.getProp('deha.user.misc.contact_person_3.salutation') ||
            this.getProp('deha.user.misc.contact_person_3.first_name') ||
            this.getProp('deha.user.misc.contact_person_3.last_name')
        ) {
            counter = 3;
        }
        this.contactPersonCount = counter;

        // set regulated profession count
        let counter_regulated_profession = 0;
        if (this.getProp('deha.user.misc.regulated_profession_applicable') === '1') {
            counter_regulated_profession = 1;
            if (
                this.getProp('deha.user.misc.regulated_profession_2.job_name') ||
                this.getProp('deha.user.misc.regulated_profession_2.chamber_name') ||
                this.getProp('deha.user.misc.regulated_profession_2.chamber_link')
            ) {
                counter_regulated_profession = 2;
            }
            if (
                this.getProp('deha.user.misc.regulated_profession_3.job_name') ||
                this.getProp('deha.user.misc.regulated_profession_3.chamber_name') ||
                this.getProp('deha.user.misc.regulated_profession_3.chamber_link')
            ) {
                counter_regulated_profession = 3;
            }
        }
        this.regulatedProfessionCount = counter_regulated_profession;

        // set stored company name
        this.companyNameStored = this.getProp('deha.user.firma1');
    },
    props: {}
};
</script>
